import apiRequest from '@lib/api-fetch';
import { ApplyBonusCardRequest } from 'types/checkout';
import { GcmResponse } from 'types/gcmResponse';


export async function applyBonusCard(param: ApplyBonusCardRequest): Promise<GcmResponse> {
  const response = await apiRequest('POST', `/bonus-card/apply`, {
    body: param,
  });
  return response.body;
}

export async function removeBonusCard(cart_id: string): Promise<GcmResponse> {
  const response = await apiRequest('DELETE', `/bonus-card/${cart_id}`, {});
  return response.body;
}

export async function reApplyBonusCard(cart_id: string): Promise<GcmResponse> {
  const response = await apiRequest('POST', `/bonus-card/re-apply`, { body: { cart_id } });
  return response.body;
}
